import { useEffect } from "react";
import styled from "styled-components";
import { Model } from "survey-core";


type ProgressHeaderProps = {
  survey: Model;
  nextButtonText: string;
  nextButtonCaption?: string | React.ReactNode;
  showCaptionSeparator?: boolean;
  disclaimer?: string | React.ReactNode;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  max-width: 640px;
  padding: 16px 50px 32px 60px;
  box-sizing: border-box;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: #0b6dff;
  font-family: Lato, sans-serif;
  font-weight: 510;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #fff;
  lign-items: center;
  cursor: pointer;
  padding: 12px 24px;
  border-radius: 50px;
  width: 100%;

  svg {
    margin-left: 10px;
  }

  @media screen and (min-width: 695px) {
    max-width: 400px;
  }
`;

export const Caption = styled.div<{ showSeparator?: boolean }>`
  font-size: 14px;
  color: #7a7a7a;
  font-style: italic;
  margin-top: 42px;
  position: relative;
  margin-bottom: 16px;
  text-align: center;

  @media screen and (min-width: 695px) {
    font-size: 16px;
  }

  ${(props) =>
    (props.showSeparator ?? true) &&
    `
    &::before {
      content: "";
      position: absolute;
      top: -42px;
      left: 50%;
      width: 94px;
      height: 0px;
      border: 2px solid #E7F0FF;
      margin-left: -47px;
    }
  `}
`;

const QuestionFooter: React.FC<ProgressHeaderProps> = ({
  survey,
  nextButtonText,
  nextButtonCaption,
  disclaimer,
  showCaptionSeparator = true,
}) => {
  const handleContinue = () => {
    survey.nextPage();
    console.log(survey.isLastPage);
    if (survey.isLastPage) {
      console.log(survey);
      survey.completeLastPage();
    }
  };

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        // Blur any currently focused input element
        const activeElement = document.activeElement as HTMLElement;
        if (activeElement && typeof activeElement.blur === "function") {
          activeElement.blur();
        }
        handleContinue();
      }
    };

    document.addEventListener("keypress", handleKeyPress);

    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [survey]);

  return (
    <Container id="question-footer-container">
      {nextButtonCaption && <Caption showSeparator={showCaptionSeparator}>{nextButtonCaption}</Caption>}
      {disclaimer && <Caption showSeparator={false}>{disclaimer}</Caption>}
      <Button onClick={handleContinue}>
        <span>{nextButtonText}</span>
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.11876 21.0098C8.60876 21.4998 9.39876 21.4998 9.88876 21.0098L18.1988 12.6998C18.5888 12.3098 18.5888 11.6798 18.1988 11.2898L9.88876 2.9798C9.39876 2.4898 8.60876 2.4898 8.11876 2.9798C7.62876 3.4698 7.62876 4.2598 8.11876 4.7498L15.3588 11.9998L8.10876 19.2498C7.62876 19.7298 7.62876 20.5298 8.11876 21.0098Z"
            fill="white"
          />
        </svg>
      </Button>
    </Container>
  );
};

export default QuestionFooter;
